import { List } from 'immutable'

export default List(['rank', 'pfv', 'age'])
